import React, { useState, useEffect } from 'react';

const BaureiheBadge = ({ serie, size = 'sm' }) => {
  const [imgError, setImgError] = useState(false);
  const uuid = serie?.trainSerieUUID || serie?.UUID;
  const label = serie?.trainSerieName || serie?.trainSerieNumber;

  useEffect(() => {
    setImgError(false);
  }, [uuid]);

  if (!serie || !label) return null;

  return (
    <span className={`baureihe-badge baureihe-badge-${size}`} title={label}>
      {!imgError && uuid ? (
        <img
          src={`/trains/${uuid}.png`}
          alt={label}
          onError={() => setImgError(true)}
          className="baureihe-img"
        />
      ) : (
        <span className="baureihe-chip">
          <i className="fa fa-train"></i> {label}
        </span>
      )}
    </span>
  );
};

export default BaureiheBadge;
